import { showToast } from "./Toast";

let isHandlingUnauthorized = false;

/** Routes served under LayoutMobileRedirection (get-started, login, manage-*, etc.) */
const MOBILE_REDIRECTION_ROUTE_PREFIXES = [
  "/login",
  "/get-started",
  "/manage-dashboard",
  "/manage-credits",
  "/manage-subscription",
  "/manage-service-area",
  "/buy-pro-plan",
  "/offer-pro-plan",
  "/pro-plan",
];

const AUTH_SCREEN_PATHS = [
  "/login",
  "/get-started",
  "/professional/login",
  "/client/login",
];

/** Client signup — do not redirect/clear storage on API errors mid-flow */
const CLIENT_SIGNUP_PATHS = ["/client/signup", "/client/signup-one"];

/** Professional signup — do not redirect/clear storage on API errors mid-flow */
const PROFESSIONAL_SIGNUP_PATHS = [
  "/professional/signup",
  "/professional/signup-one",
  "/professional/signup-two",
  "/professional/signup-three",
  "/professional/signup-four",
];

export const isClientSignupInProgress = (
  pathname = window.location.pathname
) => CLIENT_SIGNUP_PATHS.includes(pathname);

export const isProfessionalSignupInProgress = (
  pathname = window.location.pathname
) =>
  PROFESSIONAL_SIGNUP_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

/** Mobile layout: pages reachable without a session (login / onboarding) */
export const MOBILE_PUBLIC_AUTH_PATHS = ["/login", "/get-started"];

export const isMobilePublicAuthPath = (pathname = window.location.pathname) =>
  MOBILE_PUBLIC_AUTH_PATHS.includes(pathname);

export const isMobileRedirectionRoute = (
  pathname = window.location.pathname
) =>
  MOBILE_REDIRECTION_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

export const getLoginRedirectPath = () => {
  if (isMobileRedirectionRoute()) {
    return "/login";
  }
  if (window.location.pathname.startsWith("/client")) {
    return "/client/login";
  }
  return "/professional/login";
};

export const clearAuthStorage = () => {
  localStorage.clear();
};

/**
 * Clears session, shows alert, and redirects to the correct login route.
 * Skips redirect when already on a login/get-started screen (e.g. wrong password).
 */
export const handleUnauthorized = (message) => {
  if (isHandlingUnauthorized) {
    return;
  }

  const pathname = window.location.pathname;
  if (AUTH_SCREEN_PATHS.includes(pathname)) {
    return;
  }

  if (isClientSignupInProgress(pathname)) {
    showToast(
      message || "Could not save your profile. Check the console and try again.",
      "error"
    );
    isHandlingUnauthorized = false;
    return;
  }

  if (isProfessionalSignupInProgress(pathname)) {
    showToast(
      message || "Could not complete signup. Please try again.",
      "error"
    );
    isHandlingUnauthorized = false;
    return;
  }

  isHandlingUnauthorized = true;

  clearAuthStorage();

  const alertMessage =
    message ||
    "Your session has expired. Please sign in again to continue.";

  showToast(alertMessage, "error");

  window.dispatchEvent(new Event("logout"));

  window.location.replace(getLoginRedirectPath());
};

export const resetUnauthorizedGuard = () => {
  isHandlingUnauthorized = false;
};
